<template>
    <div class="edit-add-floor-wrap">
        <!--   添加区域标签   -->
        <BasicTitle title="添加区域标签"></BasicTitle>

        <!--    标签盒子    -->
        <div class="add-tags-wrap" :class="{'show-add-area-container':bAreaTagsShow}">
            <!--      添加按钮      -->
            <div @click.stop="changeAreaAddShowState" class="add-btn">
                <p v-if="objActiveAreaAdd" class="ac-text">{{ objActiveAreaAdd.name }}</p>
                <p v-else>请选择区域标签</p>
                <img class="icon" :src="require('@/assets/images/hvac/mapping/chevron-down.png')" alt="">
            </div>

            <!--     区域类型展示容器       -->
            <div v-if="bAreaTagsShow " class="add-area-container">
                <div class="area-item" v-for="item in arrAddAreaShowList" :key="item.titleKey">
                    <div class="area-item-title">{{ item.title }}</div>
                    <div class="area-children-list">
                        <div @click=" setActiveAreaAdd(child)" class="child-item" v-for="child in item.children" :class="{'active-child': (objActiveAreaAdd && objActiveAreaAdd.name && objActiveAreaAdd.name === child.name) || hasRoomsInfo(child.name)}" :key="child.nameKey">{{ child.name }}</div>
                    </div>
                </div>
            </div>

            <!--        区域内容添加容器     -->
            <div v-if="bAreaContentAddEditShow && !bAreaTagsShow" class="add-content-container">
                <!--        面积        -->
                <div class="content-item">
                    <p class="title">
                        <span>面积<span class="required-s">*</span></span>
                        <span class="tips">可直接填写面积</span>
                    </p>
                    <div class="acreage">
                        <input type="number" @blur="formatValue" v-model="objAddAreaContent.roomWidth" placeholder="长" class="input"> <span class="operation">*</span>

                        <input type="number" @blur="formatValue" v-model="objAddAreaContent.roomHeight" placeholder="宽" class="input"> <span class="operation">=</span>

                        <input type="number" @blur="formatValue" :value="roomArea" @input="roomArea = $event.target.value" placeholder="面积" class="output">
                    </div>
                </div>
                <!--        层高&朝向        -->
                <div class="content-item">
                    <p class="title"><span>层高&朝向<span class="required-s">*</span></span></p>
                    <div class="toward">
                        <input type="number" @blur="formatValue" v-model="objAddAreaContent.floorHeight" class="toward-item" placeholder="层高">
                        <input @click.prevent="changeDirectionShowState" readonly v-model="objAddAreaContent.direction" class="toward-item" placeholder="朝向">
                    </div>
                </div>

                <!--     朝向选择弹窗     -->
                <VantPopup position="bottom" round v-model="bDirectionSelectShow">
                    <VantPicker @cancel="changeDirectionShowState" @confirm="setRoomDirection" show-toolbar :columns="arrDirectionList" value-key="name"></VantPicker>
                </VantPopup>

                <!--         末端设备配置       -->
                <div class="content-item">
                    <p class="title"><span>末端设备配置</span></p>
                    <div class="device">
                        <div @click="handleSelectConfig(item.key,'configOne')" v-for="item in objAddAreaContent.deviceConfig.configOne" :key="item.key" class="btn" :class="{'active-btn': item.active}">{{ item.name }}</div>
                        <div class="double">
                            <span @click="handleSelectConfig(item.key,'configTwo')" v-for="item in objAddAreaContent.deviceConfig.configTwo" :key="item.key" :class="{'active-btn': item.active}">{{ item.name }}</span>
                        </div>
                    </div>
                </div>

                <!--        添加照片        -->
                <div class="content-item">
                    <p class="title"><span>添加照片</span></p>
                    <div class="picture">


                        <div class="image-item" v-for="(item,index) in objAddAreaContent.pictureList" :key="index">
                            <img :src="require('@/assets/images/hvac/mapping/reduce-icon.png')" @click="removePictureToConfig(item.img_url)" class="close-icon">
                            <img :src="item.img_url" alt="" class="image">
                        </div>

                        <VantUploader :afterRead="addPictureToConfig" :maxCount="1" class="image-item">
                            <img :src="require('@/assets/images/hvac/mapping/image-add-icon.png')" alt="" class="add-icon">
                        </VantUploader>

                    </div>
                </div>
            </div>

            <!--       确认按钮     -->
            <div @click="confirmAddArea" v-if="!bAreaTagsShow" class="add-btn confirm-btn" :class="{'can-confirm': canNextAddArea }"> {{ bIsEditRoomInfo ? '确认编辑' : '确认添加' }}</div>
        </div>

        <!--    已添加区域    -->
        <div v-if="!bAreaTagsShow" class="added-container">
            <!--       标题区域     -->
            <div class="add-title">
                <BasicTitle title="已添加区域"></BasicTitle>
                <div @click="$emit('floorEdit')" class="btn-edit-tag">楼层编辑</div>
            </div>
            <!--    内容    -->
            <div class="add-content-wrap">
                <!--           楼层     -->
                <div class="nav-floor">
                    <p @click="switchFloor(nav.name)" class="floor-item" :class="{'select-floor-item': nav.select}" v-for="nav in arrRoomAreaList">
                        <span class="name">{{ nav.name }}</span>
                    </p>
                </div>
                <!--         楼层资源       -->
                <div class="floor-result">
                    <div @click.stop="editRoomInfo(item)" class="floor-result-item" v-for="item in selectRoomArea.rooms">
                        <span class="name">{{ item.name }}</span>
                        <span class="value">{{ item.area + 'm²' }}</span>
                        <img @click.stop="removeRoomInfo(item)" :src="require('@/assets/images/hvac/mapping/reduce-icon.png')" class="icon">
                    </div>
                </div>
            </div>
            <!--     完成按钮       -->
            <div class="end-btn" @click="confirmEnd"> 完成</div>
        </div>

    </div>
</template>

<script>
import BasicTitle from './basictitle';
import {Popup, Picker, Uploader} from 'vant';
import {mapState} from "vuex";
import {uploadImage} from "@/js/hvac/mapping";

const {Dialog} = require("vant");

export default {
    name: "editAddFloor",
    components: {
        BasicTitle,
        VantPopup: Popup,
        VantPicker: Picker,
        VantUploader: Uploader,
    },

    data() {
        return {
            // 区域标签容器显示状态
            bAreaTagsShow: false,
            // 新增和编辑内容容器显示状态
            bAreaContentAddEditShow: false,
            // 朝向选择弹窗显示
            bDirectionSelectShow: false,
            // 是否编辑房间信息
            bIsEditRoomInfo: false,
        }
    },
    computed: {
        ...mapState({
            // 楼层数据列表
            arrRoomAreaList: state => state.hvacMappingEntry.arrRoomAreaList,
            // 添加区域展示内容数组
            arrAddAreaShowList: state => state.hvacMappingEntry.arrAddAreaShowList,
            // 当前正在添加的区域
            objActiveAreaAdd: state => state.hvacMappingEntry.objActiveAreaAdd,
            // 朝向数据
            arrDirectionList: state => state.hvacMappingEntry.arrDirectionList,
            // 添加区域标签添加内容
            objAddAreaContent: state => state.hvacMappingEntry.objAddAreaContent,
        }),
        /**
         * 房间面积填写
         */
        roomArea: {
            get() {
                const {roomWidth, roomHeight, roomArea} = this.objAddAreaContent;
                this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'roomArea', value: roomWidth * roomHeight || roomArea || ''});
                return this.objAddAreaContent.roomArea;
            },
            set(v) {
                this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'roomArea', value: v});
            }
        },
        /**
         * 选中的楼层
         */
        selectRoomArea() {
            return this.arrRoomAreaList.find(i => i.select) ?? {};
        },
        /**
         * 提交验证
         * @returns {default.computed.objAddAreaContent.floorHeight}
         */
        canNextAddArea() {
            const {direction, floorHeight: level, roomArea: area} = this.objAddAreaContent;
            return area && direction && level;
        },
    },

    methods: {
        /**
         * 请选择区域标签点击
         */
        changeAreaAddShowState() {
            if (!this.selectRoomArea.key) {
                Dialog({message: '请先编辑楼层'});
                return;
            }

            this.bAreaTagsShow = !this.bAreaTagsShow;
            if (this.bAreaContentAddEditShow) {
                this.handleCloseArea();
            }
        },
        /**
         * 改变朝向选择显示状态
         */
        changeDirectionShowState() {
            this.bDirectionSelectShow = !this.bDirectionSelectShow;
        },
        /**
         * 设置房间朝向
         */
        setRoomDirection({name: direction}) {
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'direction', value: direction});
            this.changeDirectionShowState();
        },
        /**
         * 重置添加区域显示状态
         */
        handleCloseArea() {
            this.bAreaContentAddEditShow = false;
            this.bAreaTagsShow = false;
            this.bIsEditRoomInfo = false;

            this.$store.commit({type: 'hvacMappingEntry/SAVE_ACTIVE_AREA', info: null});
            this.fullAddAreaContent();
        },
        /**
         * 完成楼层区域编辑 点击
         */
        confirmEnd() {
            this.handleCloseArea();
            this.$emit('confirmEnd');
        },
        /**
         * 设置当前编辑的区域
         * @param child
         */
        setActiveAreaAdd(child) {
            // 如果同楼层有了，就不能再加
            if (this.hasRoomsInfo(child.name)) return;

            this.$store.commit({type: 'hvacMappingEntry/SAVE_ACTIVE_AREA', info: child});
            this.bAreaTagsShow = false;
            this.bAreaContentAddEditShow = true;
        },
        /**
         * 添加区域标签中的末端设备配置点击
         * @param key
         * @param { 'configOne' | 'configTwo'} configName
         */
        handleSelectConfig(key, configName) {
            const deviceConfig = {
                ...this.objAddAreaContent.deviceConfig,
                [configName]: this.objAddAreaContent.deviceConfig[configName]?.map(i => {
                    i.active = configName === 'configTwo' ? key === i.key : key === i.key ? !i.active : i.active;
                    return i;
                })
            };
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'deviceConfig', value: deviceConfig});

        },
        /**
         * 添加一张图片
         */
        async addPictureToConfig({content} = {}) {

            const pictureList = [...this.objAddAreaContent.pictureList];

            const {data: {result: {media_url, local_url: img}}} = await uploadImage({file: content});

            pictureList.push({
                img,
                img_url: media_url
            });

            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'pictureList', value: pictureList});
        },
        /**
         * 移除一张图片
         */
        removePictureToConfig(url) {
            const pictureList = [...this.objAddAreaContent.pictureList];
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', key: 'pictureList', value: pictureList.filter(i => i.img_url !== url)});
        },
        /**
         * 确认添加区域点击
         */
        async confirmAddArea() {
            const {direction, floorHeight: level, roomArea: area, deviceConfig: {configOne, configTwo}, pictureList} = this.objAddAreaContent;
            const {name, nameKey} = this.objActiveAreaAdd ?? {};

            // 验证信息完整
            if (!this.canNextAddArea) return;
            const room = {nameKey, name, area, direction, level, FP: true, DN: true, SLP: true, NF: true, pictureList};

            // 填充配置
            [...configOne, ...configTwo].forEach(co => {
                room[co.key] = co.active;
            });


            // 填入房间
            const list = this.arrRoomAreaList.map(floor => {

                if (floor.key === this.selectRoomArea.key) {
                    if (this.bIsEditRoomInfo) {
                        // 编辑替换
                        floor.rooms = floor.rooms.map(_room => {
                            const findRoom = _room.room_id === nameKey;
                            if (findRoom) {
                                room.roomId = _room.id;
                            }

                            return findRoom ? room : _room
                        })

                    } else {
                        // 新增
                        floor.rooms.push(room);
                    }

                }
                return floor;
            });

            // 发送网络请求
            const resultRoom = await this.$store.dispatch({type: 'hvacMappingEntry/addEditRoomInfo', info: {...this.objAddAreaContent, ...this.objActiveAreaAdd, floorKey: this.selectRoomArea.key, editInfo: this.bIsEditRoomInfo, roomId: room.roomId}})

            list.map(floor => {
                if (floor.key === this.selectRoomArea.key) {
                    // 编辑替换
                    floor.rooms = floor.rooms.map(_room => {
                        const findRoom = _room.nameKey === nameKey;
                        if (findRoom) {
                            _room.room_id = resultRoom.room_id;
                            _room.id = resultRoom.id;
                        }
                        return _room
                    });
                }
                return floor;
            });

            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ROOM_AREA_LIST', list});

            this.handleCloseArea();
        },
        /**
         * 切换选择的楼层
         * @param floorName
         */
        switchFloor(floorName) {
            this.bAreaContentAddEditShow = false;
            this.bIsEditRoomInfo = false;
            this.$store.commit({type: 'hvacMappingEntry/SAVE_ACTIVE_AREA', info: null});
            this.fullAddAreaContent();
            this.$emit('switchFloor', floorName)
        },
        /**
         * 移除楼层房间
         * @param floorKey
         * @param item
         */
        removeRoomInfo(item, floorKey = this.selectRoomArea.key) {
            const list = this.arrRoomAreaList.map(floor => {
                if (floor.key === floorKey) {
                    floor.rooms = floor.rooms.filter(r => r.key !== item.nameKey).filter(r => r.id !== item.id);
                }
                return floor;
            });

            this.$store.dispatch({type: 'hvacMappingEntry/removeRoomInfo', list, deleteId: item.id || item.nameKey});
        },
        /**
         * 格式化输入的数值，确保都是数字
         */
        formatValue() {
            const {roomArea, floorHeight} = this.objAddAreaContent;
            const info = {
                ...this.objAddAreaContent,
                roomArea: Number.parseFloat(roomArea) || '',
                floorHeight: Number.parseFloat(floorHeight) || '',
            };
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', info});
        },
        /**
         * 判断是否添加了房间
         * @param name
         */
        hasRoomsInfo(name) {
            return this.selectRoomArea.rooms?.some(i => i.name === name);
        },
        /**
         * 填充编辑区域信息
         * @param item roomItem
         */
        fullAddAreaContent(item = {}) {
            const {area, direction, level, pictureList, long, wide} = item;

            const info = {
                ...this.objAddAreaContent,
                roomWidth: long ?? '', // 长
                roomHeight: wide ?? '', // 宽
                roomArea: area ?? '',
                floorHeight: level ?? '',
                direction: direction ?? '',
                pictureList: pictureList ?? [],
                deviceConfig: {
                    configOne: this.objAddAreaContent.deviceConfig.configOne.map(i => {
                        i.active = item[i.key] ?? false;
                        return i;
                    }),
                    configTwo: this.objAddAreaContent.deviceConfig.configTwo.map(i => {
                        i.active = item[i.key] ?? false;
                        return i;
                    })
                }
            };
            // 填充编辑信息
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_ADD_AREA_CONTENT', info});
        },
        /**
         * 以添加区域点击编辑
         */
        editRoomInfo(item) {

            this.fullAddAreaContent(item);
            // 填充激活的房间
            const info = this.arrAddAreaShowList.map(i => i.children).flat(Infinity).find(i => i.name === item.name);

            this.$store.commit({type: 'hvacMappingEntry/SAVE_ACTIVE_AREA', info});
            // 设置编辑状态
            this.bIsEditRoomInfo = true;
            // 打开编辑
            this.bAreaContentAddEditShow = true;
        },

    }
}
</script>

<style scoped lang="scss">
.edit-add-floor-wrap {
    .add-tags-wrap {
        padding: 32px 0;
        background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x left bottom / 18px 2px;
        margin-bottom: 32px;

        .add-btn {
            background: #FFFFFF;
            height: 80px;
            border-radius: $commonRadius;
            border: 1px solid #DBDBDB;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-bottom: 24px;

            .ac-text {
                color: $deepGreen;
            }

            .icon {
                width: 32px;
                height: 32px;
                position: absolute;
                right: 24px;
            }
        }

        .confirm-btn {
            color: #A2A2A2;
            background: #EBEBEB;
            border: none;
            margin-bottom: 0;
            transition: all 0.5s;
        }

        .can-confirm {
            background: $userBgGradient;
            color: #FFFFFF;
        }

    }

    .show-add-area-container {
        background: none #F7F7F7;
        border-radius: 0 0 $commonRadius $commonRadius;
        padding-top: 0;
        padding-bottom: 28px;
        margin-top: 32px;

        .add-area-container {
            padding: 6px 24px 0;
            height: 60vh;
            overflow-y: auto;

            .area-item {
                margin-bottom: 28px;

                &:last-of-type {
                    margin-bottom: 0;
                }

                .area-item-title {
                    line-height: 40px;
                    padding: 0 18px;
                    background: linear-gradient(to right, $deepGreen, $deepGreen) no-repeat center left / 6px 26px;
                    height: 40px;
                }

                .area-children-list {
                    display: flex;
                    flex-wrap: wrap;

                    .child-item {
                        flex: 0 0 146px;
                        height: 56px;
                        line-height: 56px;
                        text-align: center;
                        color: #858585;
                        background: #FFFFFF;
                        border-radius: $commonRadius;
                        margin: 20px 20px 0 0;

                        &:nth-child(4n + 4) {
                            margin-right: 0;
                        }
                    }

                    .active-child {
                        color: $deepGreen;
                    }
                }
            }
        }
    }

    .add-content-container {
        color: #A2A2A2;

        .content-item {
            .required-s {
                padding-left: 4px;
                color: red;
            }


            .title {
                color: $commonText;
                display: flex;
                align-items: center;
                justify-content: space-between;
                line-height: 40px;
                margin-bottom: 16px;

                .tips {
                    color: #A2A2A2;
                    font-size: $smallSize;
                }
            }

            &:last-of-type {
                .title {
                    margin-bottom: 0;
                }
            }

            input {
                color: #444444;
                background: #F7F7F7;
                height: 80px;
                border-radius: $commonRadius;
                text-align: center;
                padding: 0 12px;

                &::placeholder {
                    color: #A2A2A2;
                }
            }

            .acreage {
                display: flex;
                align-items: center;
                margin-bottom: 28px;


                .input {
                    flex: 0 0 auto;
                    width: 182px;
                }

                .output {
                    flex: 0 0 auto;
                    width: 220px
                }

                .operation {
                    flex: 1;
                    text-align: center;
                }


            }

            .toward {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 28px;

                .toward-item {
                    width: 336px;
                }
            }

            .device {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 24px;

                .btn {
                    background: #F7F7F7;
                    height: 80px;
                    border-radius: $commonRadius;
                    text-align: center;
                    padding: 0 12px;
                    line-height: 80px;
                    width: 208px;
                    margin-right: 18px;
                }

                .active-btn {
                    background: $deepGreen;
                    color: #FFFFFF;
                }

                .double {
                    width: 236px;
                    height: 80px;
                    display: flex;
                    font-size: 24px;
                    color: $deepGreen;
                    border: 1px solid $deepGreen;
                    border-radius: $commonRadius;
                    overflow: hidden;

                    span {
                        flex: 1;
                        line-height: 80px;
                        text-align: center;

                        &:first-child {
                            border-right: 1px solid $deepGreen;
                        }
                    }
                }
            }

            .picture {
                display: flex;
                align-items: center;
                margin-bottom: 24px;
                padding-top: 16px;
                overflow-x: auto;


                .image-item {
                    flex: 0 0 auto;
                    width: 158px;
                    height: 158px;
                    margin-right: 22px;
                    background: #F3F3F3;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .add-icon {
                        width: 46px;
                        height: 46px;
                    }

                    .close-icon {
                        width: 32px;
                        height: 32px;
                        position: absolute;
                        top: -16px;
                        right: -16px;
                        border-radius: 100%;
                    }
                }
            }
        }
    }


    .added-container {

        .add-title {
            position: relative;
            height: 52px;
            margin-bottom: 22px;


            .btn-edit-tag {
                width: 136px;
                line-height: 52px;
                text-align: center;
                height: 52px;
                border-radius: $littleRadius;
                border: 2px solid $deepGreen;
                color: $deepGreen;
                font-size: $smallSize;
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        .add-content-wrap {
            .nav-floor {
                display: flex;
                align-content: center;
                overflow-x: auto;


                .floor-item {
                    white-space: nowrap;
                    margin-right: 100px;
                    margin-bottom: 32px;
                    height: 52px;
                    width: max-content;
                    display: flex;
                    align-items: flex-start;
                    color: #A2A2A2;

                    .name {
                        line-height: 40px;
                    }

                    &:last-of-type {
                        margin-right: 0;
                    }
                }

                .select-floor-item {
                    color: $deepGreen;
                    font-weight: 500;
                    background: linear-gradient(to right, $deepGreen, $deepGreen) no-repeat bottom center / 100% 4px;
                }
            }

            .floor-result {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 180px;

                .floor-result-item {
                    flex: 0 0 336px;
                    border-radius: $commonRadius;
                    background: #F7F7F7;
                    font-size: $baseSize;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    padding: 20px;

                    .name {
                        flex: 0 0 auto;
                        width: max-content;
                        line-height: 40px;
                    }

                    .value {
                        flex: 1;
                        text-align: right;
                        line-height: 40px;
                    }

                    .icon {
                        flex: 0 0 auto;
                        width: 32px;
                        height: 32px;
                        margin-left: 50px;
                    }
                }

            }

        }

        .end-btn {
            height: 100px;
            background: $userBgGradient;
            border-radius: $commonRadius;
            line-height: 100px;
            text-align: center;
            color: #FFFFFF;
            font-size: $bigSize;
        }
    }
}
</style>